import React from 'react';
import { List, ListItem } from 'fronton-react';
import { useNavigate } from '../hooks';

export interface NotFoundSuggestionProps {
  searchQuery: string;
  searchHref: string;
  notFoundMessage?: string | false;
}

export const NotFoundSuggestion = (props: NotFoundSuggestionProps) => {
  const { searchQuery, searchHref, notFoundMessage } = props;
  const navigate = useNavigate();

  return (
    <List>
      <ListItem
        value=""
        text={notFoundMessage || `Искать «${searchQuery}»`}
        onClick={() => navigate(`${searchHref}?q=${searchQuery}&suggest=true`)}
      />
    </List>
  );
};
